import { ExampleElement } from '@swagger-api/apidom-ns-openapi-3-0';
class Example extends ExampleElement {}
export default Example;